import * as tslib_1 from "tslib";
import { StorageService } from '@apps/ui';
export class LoadService {
    constructor(storage) {
        this.storage = storage;
    }
    initializeApp() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // load config
            const config = {};
            this.storage.setItem('config', config);
            return true;
        });
    }
}
